export const PHONE_PLACEHOLDER = 'XXX-XXX-XXXX';
